import { render, staticRenderFns } from "./CancelReview.vue?vue&type=template&id=65d412f2&"
import script from "./CancelReview.vue?vue&type=script&lang=js&"
export * from "./CancelReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65d412f2')) {
      api.createRecord('65d412f2', component.options)
    } else {
      api.reload('65d412f2', component.options)
    }
    module.hot.accept("./CancelReview.vue?vue&type=template&id=65d412f2&", function () {
      api.rerender('65d412f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cancel/CancelReview.vue"
export default component.exports